(function ($) {
  $(document).ready(function () {
    if ($(".quotes-slider").length > 0) {
      // Animate counter function
      const animateCounter = ($element, target, suffix) => {
        const duration = 2000; // 2 seconds
        const start = 0;
        const increment = target / (duration / 16); // 60fps
        let current = start;

        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }

          $element.text(Math.floor(current) + suffix);
        }, 16);
      };

      // Run a single counter based on its data attributes
      const runCounter = ($counter) => {
        const $item = $counter.closest(".item");
        const target = parseInt($counter.data("target"), 10) || 0;
        const suffix = $counter.data("suffix") || "";

        if ($item.hasClass("stop-counter")) {
          $counter.text(target + suffix);
          return;
        }

        if (target > 0) {
          animateCounter($counter, target, suffix);
        } else {
          $counter.text(target + suffix);
        }
      };

      // Helper: observe counters and start when they enter viewport
      const setupViewportCounters = () => {
        const $counters = $(".quotes-slider .count-wrap");
        if (!$counters.length) return;

        if ("IntersectionObserver" in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const $el = $(entry.target);
                  if (!$el.data("has-counted")) {
                    $el.data("has-counted", true);
                    runCounter($el);
                  }
                }
              });
            },
            {
              threshold: 0.3,
            }
          );

          $counters.each(function () {
            observer.observe(this);
          });
        } else {
          // Fallback for older browsers: simple scroll handler
          const onScroll = () => {
            $counters.each(function () {
              const $el = $(this);
              if ($el.data("has-counted")) return;

              const rect = this.getBoundingClientRect();
              const inView =
                rect.top < window.innerHeight * 0.7 && rect.bottom > 0;

              if (inView) {
                $el.data("has-counted", true);
                runCounter($el);
              }
            });
          };

          $(window).on("scroll resize", onScroll);
          onScroll(); // run once on load
        }
      };

      // Add active class after a short delay and init slider
      setTimeout(function () {
        $(".quotes-slider").addClass("active");

        // Initialize Slick slider if multiple quote items
        if ($(".quotes-slider .item").length > 1) {
          $(".quotes-slider .slide-wrapper")
            .slick({
              autoplay: false,
              autoplaySpeed: 5000,
              dots: true,
              arrows: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              cssEase: "ease-in-out",
            })
            .on("init", function () {
              $(this).addClass("slick-ready");
            });
        } else {
          // If only one slide, just show it without slick
          $(".quotes-slider .slide-wrapper").addClass("slick-ready");
        }

        // Start observing counters after slider is ready
        setupViewportCounters();
      }, 200);
    }
  });
})(jQuery);